var _clipPath, _use, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAddStory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    xmlns: "http://www.w3.org/2000/svg",
    height: 90,
    id: "screenshot-53058554-625b-8072-8007-3e8643ed7c3a",
    viewBox: "0 0 90 90",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-53058554-625b-8072-8007-3e8643ed7c3a",
    rx: 0,
    ry: 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-53058554-625b-8072-8007-3e84c2a73302"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-53058554-625b-8072-8007-3e84c2a73302"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,0C69.836181640625,0,90,20.163818359375,90,45C90,69.836181640625,69.836181640625,90,45,90C20.163818359375,90,4.547473508864641e-13,69.836181640625,4.547473508864641e-13,45C4.547473508864641e-13,20.163818359375,20.163818359375,0,45,0",
    style: {
      fill: "rgb(255, 255, 255)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "strokes-2eacc020-df50-80e6-8007-3efe44fbd1c0-53058554-625b-8072-8007-3e84c2a73302",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "inner-stroke-shape"
  }, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "inner-stroke-render-2-53058554-625b-8072-8007-3e84c2a73302-0"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-2-53058554-625b-8072-8007-3e84c2a73302-0"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M45,0C69.836181640625,0,90,20.163818359375,90,45C90,69.836181640625,69.836181640625,90,45,90C20.163818359375,90,4.547473508864641e-13,69.836181640625,4.547473508864641e-13,45C4.547473508864641e-13,20.163818359375,20.163818359375,0,45,0",
    id: "stroke-shape-render-2-53058554-625b-8072-8007-3e84c2a73302-0",
    style: {
      fill: "none",
      strokeWidth: 16,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#stroke-shape-render-2-53058554-625b-8072-8007-3e84c2a73302-0",
    clipPath: "url('#inner-stroke-render-2-53058554-625b-8072-8007-3e84c2a73302-0')"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "shape-53058554-625b-8072-8007-3e860ba244b3"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-53058554-625b-8072-8007-3e860ba244b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0166015625,45L51.26318359375,45L45.00341796875,45L30,45M45.00341796875,29.9967041015625L45.00341796875,38.7501220703125L45.00341796875,45L45.00341796875,60.0133056640625"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "strokes-2eacc020-df50-80e6-8007-3efe44fcd545-53058554-625b-8072-8007-3e860ba244b3",
    className: "strokes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "stroke-shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0166015625,45L51.26318359375,45L45.00341796875,45L30,45M45.00341796875,29.9967041015625L45.00341796875,38.7501220703125L45.00341796875,45L45.00341796875,60.0133056640625",
    style: {
      fill: "none",
      strokeWidth: 4,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeLinecap: "round"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddStory);
export default __webpack_public_path__ + "static/media/icon-add-story.19e9b7cd4f3fcb3eee54b293f7580d4c.svg";
export { ForwardRef as ReactComponent };